import EncodingsCQ from 'api/EncodingsCQ'
import { CQLotInfo } from 'api/types'
import { Box, Card, Spacer, Table, Button, Image } from 'components'
import React, { Component } from 'react'
import { Counter, CounterContainer } from '../pages/QualityControl/QualityProvider'

interface Props {
  lot: CQLotInfo
}

export default class LottoInfoBox extends Component<Props> {
  downloadPDF = async () => {
    const { lot } = this.props
    await EncodingsCQ.getCQLotPdfInfo(lot.code)
  }

  render() {
    const { lot } = this.props
    const date = new Date(lot.creationDate).toLocaleDateString()
    const time = new Date(lot.creationDate).toLocaleTimeString()
    const dateTime = `${date} ${time}`
    return (
      <Box style={{ padding: 20 }}>
        <CounterContainer row>
          <Box style={{ width: '50%' }}>
            <Image //temporanea, da sostituire con vero barcode
              style={{ height: 100, paddingTop: 10 }}
              src={`data:image/jpeg;base64,${lot.barcode}`}
              alt="Barcode"
            />
          </Box>
          <Box style={{ width: '50%', padding: 5 }}>
            <Card title="Lot" nomargin>
              <Counter>{lot.code}</Counter>
            </Card>
          </Box>
        </CounterContainer>
        <CounterContainer row>
          <Box style={{ width: '50%', padding: 5 }}>
            <Card title="N. pezzi battezzati" nomargin>
              <Counter>{lot.testedTotalCount}</Counter>
            </Card>
          </Box>
          <Box style={{ width: '50%', padding: 5 }}>
            <Card title="Data e ora" nomargin>
              <Counter>{dateTime}</Counter>
            </Card>
          </Box>
        </CounterContainer>
        {lot.testedPerFitSizeQuantities.length > 0 && (
          <Box flex style={{ overflowY: 'auto', maxHeight: '300px' }}>
            <Table
              structure={[
                { label: 'Taglia', value: 'size' },
                { label: 'Calzata', value: 'fit' },
                { label: 'Quantità', value: 'quantity' },
              ]}
              data={lot.testedPerFitSizeQuantities}
            />
          </Box>
        )}
        <Spacer />
        <Box flex center>
          <Button title="Scarica" style={{ width: '50%' }} onClick={() => this.downloadPDF()} />
        </Box>
      </Box>
    )
  }
}
